export default "__VITE_ASSET__DKImFYgZ__"